export default __webpack_public_path__ + "static/media/rightman.3100a636.png";